export class User {
    kullanici_id : string;
    tckimlikno : string;
    adisoyadi  : string;
    adi  : string;
    soyadi  : string;
    Rol        : string[];

    constructor() {
        this.kullanici_id = "";
        this.tckimlikno = "";
        this.adisoyadi = "";
        this.adi = "";
        this.soyadi = "";
        this.Rol = [];
    }
}
